/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Mon May 23 2022
*  File : PersonalDataHandler.ts
*******************************************/

import { isFunction, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";


export type PersonalDataStorageInterface = {


    setWizardCompleted(): void,
    isWizardCompleted(): Promise<boolean>,
    setNotificationsUnsubscribed(): void,
    unsetNotificationsUnsubscribed(): void,
    isNotificationsUnsubscribed(): Promise<boolean>,
    setCTALastShowed(): void,
    setSexAndRange(sar: string): void,
    getCTALastShowed(): Promise<number>,

    /**
     * Imposta l'opt out dei cookie di tracciamento
     * Impostare true significa abilitare il tracciamento, false significa disabilitare il tracciamento
     * @param v 
     */
    setTrackingOptOut(v: boolean): Promise<void>;
    /**
     * Restituisce lo stato corrente dei cookie di tracciamento.
     * True indica che il tracciamento è permesso, false che non è permesso
     */
    getTrackingOptOut(): Promise<boolean>;

};

export function isPersonalDataStorageInterface(obj: any): obj is PersonalDataStorageInterface {
    return isObject(obj) && 
            isFunction(obj.setWizardCompleted) &&
            isFunction(obj.isWizardCompleted) &&
            isFunction(obj.setNotificationsUnsubscribed) &&
            isFunction(obj.unsetNotificationsUnsubscribed) &&
            isFunction(obj.isNotificationsUnsubscribed) &&
            isFunction(obj.setCTALastShowed) &&
            isFunction(obj.setSexAndRange) &&
            isFunction(obj.getCTALastShowed) &&
            isFunction(obj.setTrackingOptOut) &&
            isFunction(obj.getTrackingOptOut);
}



export type PersonalDataStorageMethod = keyof PersonalDataStorageInterface;

export const AllPersonalDataStorageMethods: PersonalDataStorageMethod[] =
    [
        "setWizardCompleted", 
        "isWizardCompleted", 
        "setNotificationsUnsubscribed",
        "unsetNotificationsUnsubscribed",
        "isNotificationsUnsubscribed",
        "getCTALastShowed",
        "setCTALastShowed",
        "setSexAndRange",
        "setTrackingOptOut",
        "getTrackingOptOut"
    ];   
